export {
  projects
}
let projects=[
  {
    image:require('@/assets/project/project1.jpg'),
    name:'软件定制开发',
    content:'我们的软件定制开发服务涵盖了广泛的行业和领域，旨在满足客户个性化的需求和挑战。通过深入了解客户的业务流程和需求，我们的团队将为您量身定制高质量的软件解决方案，以提升您的业务效率、优化流程，并实现数字化转型。我们以灵活、高效和可靠的开发流程，为客户提供全方位的支持，从概念设计到部署和维护，确保交付符合预期，并为客户带来持久的价值。',
    id:101
  },
  // {
  //   image:require('@/assets/project/project2.jpg'),
  //   name:'IT外包服务',
  //   content:'',
  //   di:102
  // },
  {
    image:require('@/assets/project/project3.jpg'),
    name:'网上商城建设',
    content:'我们将根据您的品牌形象和市场定位，为您打造独具特色的网上商城界面，提升用户体验和品牌认知度。为您提供直观、易用的管理后台，让您能够轻松管理商品、订单、库存等信息，实现对网上商城的全面管理和控制。我们提供营销策略制定和推广支持，帮助您吸引更多的潜在客户，提升网站流量和销售量。',
    id:103
  },
  {
    image:require('@/assets/project/project4.png'),
    name:'机械设备研发',
    content:'我们的团队致力于为各种行业的客户提供高效、可靠的机械设备解决方案，从概念设计到工程开发，我们的团队具备全面的设计和工程能力。我们与客户紧密合作，了解其需求和目标，然后利用最先进的设计工具和技术，开发出创新的机械设备方案。我们注重工程设计的可行性和可靠性，确保最终产品符合客户的期望和要求。',
    id:104
  },
  {
    image:require('@/assets/project/project5.jpg'),
    name:'集成电路设计',
    content:'我们不仅致力于为客户提供高质量的集成电路设计方案，还努力为客户创造长期价值。通过优化客户的业务流程和提升其产品性能，我们帮助客户提高竞争力，实现持续发展，无论您是需要定制化的电子产品还是面临特定技术挑战的企业，我们都能够为您提供量身定制的集成电路设计解决方案。我们的团队将竭诚为您服务，确保您的项目成功并超出预期。',
    id:105
  },
  
]
